



























import { computed, defineComponent, useRoute } from '@nuxtjs/composition-api'

export default defineComponent({
  props: {
    steps: {
      type: Array,
      required: true,
    },
    enableNextSteps: {
      type: Boolean,
      default: false,
    },
    disablePrevSteps: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const route = useRoute()
    const currentStep = computed(() => {
      const step: any = props.steps.filter((step: any) => {
        return step.path === route.value.path
      })
      if (step.length > 0) {
        return step[0].step
      }
    })
    return { currentStep }
  },
})
